module.exports = __webpack_public_path__ + "img/security.a40ecfb2.svg";